module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai657-cf1410ba6d259f64053a8bf04d1c60ac.jpg";